import { t } from "i18next";
import * as z from "zod";

import { CUSTOMER_SEGMENTS } from "@/features/shared/api/enums";

/**
 * Schéma du formulaire de contribution à une cagnotte (transaction
 * `POT_CONTRIBUTION` via `POST /Transactions/initiate`, guide §5.3) —
 * montant saisi en unité MAJEURE (converti en `amountMinor` au submit via
 * `majorToMinor`). La destination est le portefeuille de la collecte
 * (interne, `destinationExternalType = NONE` au submit).
 *
 * Factory (règle projet) : créé via `createContributionSchema()` et
 * mémoïsé au niveau composant sur la langue courante — jamais d'instance
 * exportée.
 */
export const createContributionSchema = () =>
  z.object({
    productCode: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    sourceWalletId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
    destinationWalletId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
    amount: z
      .number({ invalid_type_error: t("invalidFieldError") })
      .positive({ message: t("invalidFieldError") }),
    customerSegment: z.enum(CUSTOMER_SEGMENTS, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    partyId: z
      .string()
      .trim()
      .uuid({ message: t("invalidFieldError") })
      .or(z.literal(""))
      .optional(),
    customerReference: z.string().trim().or(z.literal("")).optional(),
  });

export type ContributionFormValues = z.infer<
  ReturnType<typeof createContributionSchema>
>;
